import { render, staticRenderFns } from "./activity-form-preview-columns.vue?vue&type=template&id=6dfb6c8e&scoped=true&"
import script from "./activity-form-preview-columns.vue?vue&type=script&lang=js&"
export * from "./activity-form-preview-columns.vue?vue&type=script&lang=js&"
import style0 from "./activity-form-preview-columns.vue?vue&type=style&index=0&id=6dfb6c8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb6c8e",
  null
  
)

component.options.__file = "activity-form-preview-columns.vue"
export default component.exports